export default __webpack_public_path__ + "static/media/Cattura15.2513c8a6.jpg";